// extracted by mini-css-extract-plugin
export default {"badge":"BookingCodeBadge_badge__kCxex","unavailable":"BookingCodeBadge_unavailable__RTEgO","compact":"BookingCodeBadge_compact__QxLra"};